import { render, staticRenderFns } from "./FormDecanter.vue?vue&type=template&id=5ed096c5&scoped=true&"
import script from "./FormDecanter.vue?vue&type=script&lang=js&"
export * from "./FormDecanter.vue?vue&type=script&lang=js&"
import style0 from "./FormDecanter.vue?vue&type=style&index=0&id=5ed096c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed096c5",
  null
  
)

export default component.exports